export default class GoogleTagAdapter {
  static push(func) {
    window.googletag.cmd.push(function() {
      func();
    });
  }

  static pubads() {
    return window.googletag.pubads();
  }

  static companionAds() {
    return window.googletag.companionAds();
  }

  static enableVideoAds() {
    return GoogleTagAdapter.pubads().enableVideoAds();
  }

  static defineSlot(ad_slot, ad_size, ad_name) {
    return window.googletag
      .defineSlot(ad_slot, ad_size, ad_name)
      .addService(GoogleTagAdapter.pubads());
  } 

  static defineSlotWithCompanionAds(ad_slot, ad_size, ad_name) {
    return window.googletag
      .defineSlot(ad_slot, ad_size, ad_name)
      .addService(GoogleTagAdapter.companionAds())
      .addService(GoogleTagAdapter.pubads());
  } 

  static collapseEmptyDivs() {
    GoogleTagAdapter.pubads().collapseEmptyDivs();
  }

  static setTargeting(key, value) {
    GoogleTagAdapter.pubads().setTargeting(key, value);
  }

  static refresh(slot) {
    GoogleTagAdapter.pubads().refresh(slot);
  }

  static addEventListener(eventName, func) {
    GoogleTagAdapter.pubads().addEventListener(eventName, func);
  }

  static enableLazyLoad(options) {
    GoogleTagAdapter.pubads().enableLazyLoad(options);
  }
}